import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const WhileLoopActionDetail = ({
  messageLangPath = 'actionDetail'
}) => {
  if (messageLangPath === 'actionDetail') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "Repeat until the condition is no longer met"
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "actionPreview"
    });
  }
};
export default WhileLoopActionDetail;